import { _ as _assocIndexOf } from "./auth-service-tools1292.js";
var assocIndexOf = _assocIndexOf;

function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}

var _listCacheSet = listCacheSet;
export { _listCacheSet as _ };